import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import applyErrorSuppression from './utils/errorSuppression';

// Apply error suppression to hide non-critical browser console errors
applyErrorSuppression();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);